import { defineMessages } from 'react-intl';

export default defineMessages({
    doingRateMessage: {
        id: 'rewrite.eu.views.riskAnalysis.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    lossesAndViolationTabHeading: {
        id: 'rewrite.eu.views.riskAnalysis.lossesAndViolation.Losses & Violations',
        defaultMessage: 'Losses & Violations'
    },
    miscellaneaousReportsTabHeading: {
        id: 'rewrite.eu.views.riskAnalysis.miscellaneaousReports.Miscellaneous Reports',
        defaultMessage: 'Miscellaneous Reports'
    },
    creditTabHeading: {
        id: 'rewrite.eu.views.riskAnalysis.credit.Credit',
        defaultMessage: 'Credit'
    }
});
